<template>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="customer-label-group mb-3">
                <div class="historyheader text-center">
                    Driving Licence Details
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8 col-md-8 col-12 mx-auto">
            <div class="driving-card-front-outer">
                <div>
                    <div>
                        <img @dragstart.prevent @contextmenu.prevent src="/assets/images/driving-card-images/dlTop.png"
                            class="" alt :style="{ height: '75px', width: '100%' }" />
                    </div>
                    <div class="driving-card-header-padding">
                        <div class="d-flex align-items-top">
                            <div class="driving-card-detail-inner">
                                <div class="d-flex justify-content-around driving-name text-uppercase">
                                    {{
                                        props.tenantdriving.ah7
                                            ?
                                            props.tenantdriving.ah7
                                            : "N/A"
                                    }}</div>
                                <div class="d-flex justify-content-around align-items-center">
                                    <div>
                                        <div class="driving-name text-capitalize">
                                            Issue Date</div>
                                        <div class="driving-card-number-header text-uppercase">
                                            {{
                                                format_dateonlystamp(props.tenantdriving.ah21)
                                            }}</div>
                                    </div>
                                    <div>
                                        <div class="driving-name text-capitalize">
                                            Validity</div>
                                        <div class="driving-card-number-header text-uppercase">
                                            {{
                                                format_dateonlystamp(props.tenantdriving.ah19)
                                            }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-shrink-0 d-flex align-items-center pt-2">
                                <img @dragstart.prevent @contextmenu.prevent v-if="
                                    props.tenantdriving.ah25 != null &&
                                    props.tenantdriving.ah25 != ''
                                "
                                    :src="state.masterbucketstoragepath + state.master_bucket_driving_photo + '/' + props.tenantdriving.ah25"
                                    class="rounded bg-light me-auto d-block" alt :style="{ width: '60px' }" />
                                <img @dragstart.prevent @contextmenu.prevent v-else src="/assets/images/profile.png" class="rounded bg-light me-auto d-block" alt
                                    :style="{ width: '60px' }" />
                            </div>
                        </div>
                        <div>
                            <span class="driving-name text-capitalize">Name:
                            </span><span class="driving-card-number-header text-capitalize">{{
                                props.tenantdriving.ah8
                                    ?
                                    props.tenantdriving.ah8
                                    : "N/A"
                            }}</span>
                        </div>
                        <div>
                            <span class="driving-name">Date of Birth:
                            </span><span class="driving-card-number-header text-capitalize">{{
                                format_dateonlystamp(props.tenantdriving.ah18)
                                }}</span>
                        </div>
                        <div>
                            <span class="driving-name">Gender:
                            </span><span class="driving-card-number-header text-capitalize">{{
                                props.tenantdriving.ah16
                                    ?
                                    props.tenantdriving.ah16
                                == 1
                                ? "Male"
                                :
                                props.tenantdriving.ah16
                                == 2
                                ? "Female"
                                : "Others"
                                : "N/A"
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="driving-card-front-outer">
                <div>
                    <div>
                        <img @dragstart.prevent @contextmenu.prevent
                            src="/assets/images/driving-card-images/dl-back-header.png" class="" alt
                            :style="{ height: '48px', width: '100%' }" />
                    </div>
                    <div class="d-flex justify-content-around driving-name text-uppercase"
                        :style="{ position: 'absolute', top: '13px', paddingLeft: '10%' }">
                        {{
                            props.tenantdriving.ah7
                                ?
                                props.tenantdriving.ah7
                                : "N/A"
                        }}</div>
                    <div class="driving-card-header-padding pt-3">
                        <div>
                            <span class="driving-name text-capitalize">Temporary
                                Address:
                            </span><span class="driving-card-number-header text-capitalize">{{
                                props.tenantdriving.ah11
                                    ?
                                    props.tenantdriving.ah11
                                    : "N/A"
                            }}</span>
                        </div>
                        <div>
                            <span class="driving-name text-capitalize">Permanent
                                Address:
                            </span><span class="driving-card-number-header text-capitalize">{{
                                props.tenantdriving.ah9
                                    ?
                                    props.tenantdriving.ah9
                                    : "N/A"
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, reactive, onMounted } from 'vue';
import commonFunction from "../../composables/commonFunction"
const { format_dateonlystamp } = commonFunction()
import { useStore } from "vuex";
const store = useStore();
const state = reactive({
    masterbucketstoragepath: "",
    master_bucket_driving_photo: '',
})
onMounted(() => {
    const loggedUserData = store.state.loggedInUserSessions;
    if (loggedUserData) {
        state.masterbucketstoragepath = loggedUserData.master_bucket_storage_path;
        state.master_bucket_driving_photo = loggedUserData.master_bucket_driving_photo;
    }
});
const props = defineProps({
    id: {
        type: [String, Number],
        required: true,
    },
    tenantdriving: Object,
});

</script>
<style scoped>
.agreement-sub-tab-outer .historyheader {
    color: #0f0f0f;
    font-size: 18px;
    font-family: "OpenSans-Regular";
    line-height: 30px;
    text-align: center;
    margin-bottom: 15px;
}
</style>